module.exports = __webpack_public_path__ + "static/media/16371641210_97be146dea_o.b62af0c4.jpg";